import { Typography } from '@workspace/ui/common';

interface ContentCarouselHeaderProps {
  heading?: unknown;
  resolvedHeadingText?: string;
}

export function ContentCarouselHeader({ heading, resolvedHeadingText }: ContentCarouselHeaderProps) {
  if (!heading || !resolvedHeadingText) return null;

  return (
    <Typography
      variant="h2"
      className="font-bold! text-black font-heading mb-2 text-left w-full md:max-w-131.25 line-clamp-2 "
      styleVariant="h3"
    >
      {resolvedHeadingText}
    </Typography>
  );
}
